define('util/searchFacetFactory',[
    'lib/lodash4',
    'lib/knockout',
    'moment',
    'viewModels/ViewModel'

], function (
    _,
    ko,
    moment,
    ViewModel
    ) {
    "use strict";

    var MILLISECONDS_PER_HOUR = 3600000;
    var MILLISECONDS_PER_MINUTE = 60000;
    var MILLISECONDS_PER_SECOND = 1000;
    var MAX_SUPPORTED_DURATION = (100 * 3600000) + (59 * 60000) + (59 * 1000);

    var SearchFacetFactory = function() {
        var self = this;

        // ===============================================================================
        // List of types this factory serves
        // ===============================================================================
        self.SEARCH_FILTER_TYPE = {
            AGENT: 'agentId',
            ANI: 'ani',
            DATERANGE: 'interval',
            DIRECTION: 'direction',
            DNIS: 'dnis',
            DURATION: 'duration',
            EVALUATION_FORM: 'qualityEvaluationForm',
            EVALUATED_AGENT: 'qualityEvaluationAgent',
            EVALUATOR: 'qualityEvaluator',
            QUEUES: 'queueId',
            FREETEXT: 'freeText',
            WRAPUPCODE: 'wrapupCode',
            QUALITYEVALUATIONSCORE: 'qualityEvaluationScore',
            QUALITYEVALUATIONCRITICALSCORE: 'qualityEvaluationCriticalScore',
            MEDIATYPE: 'mediaType'
        };

        /**
         * Utility Functions
         */

        var padded = function(number) {
            return ("00" + number).substr(-2, 2);
        };

        /**
         * Format milliseconds passed into the function
         * @param dateRange
         * @returns {String}
         */
        var formattedDuration = function(milliseconds) {
            var total = milliseconds;
            var hours = Math.floor(total / MILLISECONDS_PER_HOUR);
            total = total - (hours * MILLISECONDS_PER_HOUR);
            var minutes = Math.floor(total / MILLISECONDS_PER_MINUTE);
            total = total - (minutes * MILLISECONDS_PER_MINUTE);
            var seconds = Math.floor(total / MILLISECONDS_PER_SECOND);

            if (hours > 0) {
                return ko.i18n.renderString("durationFacet.hhmmss", { hours: hours, minutes: padded(minutes), seconds: padded(seconds) });
            }
            return ko.i18n.renderString("durationFacet.mmss", { minutes: minutes, seconds: padded(seconds) });
        };


        /**
         *  END UTIL FUNCTIONS
         */

        var Facet = ViewModel.extend(function( options, removeItemCallback, updateCallback ) {
            var self = this;
            self.id = options.id || "default";
            self.target = options.target || "default" ;
            self.displayString = options.displayString;
            self.filterTitle = options.filterTitle;
            self.operator = options.operator;
            self.cssClass = options.cssClass;
            self.multiSelect = ko.observable(false);
            self.facetObservable = ko.observableArray(null);

            if(options.cannedOptions) {
                self.cannedOptions = options.cannedOptions;
            }

            if(_.isFunction(removeItemCallback)) {
                self.removeItem = removeItemCallback;
            }

            if(_.isFunction(updateCallback)) {
                self.addUpdateCallback = updateCallback;
            }

            return self;
        });

        var ListedItemFacet = function ( facetObject, removeItemCallback, updateCallback ) {
            var listedItemFacet = new Facet (facetObject, removeItemCallback, updateCallback);
            listedItemFacet.custom = facetObject.custom;
            listedItemFacet.customConstructorArgs = facetObject.custom.customConstructorArgs;
            listedItemFacet.listedItems = { values: ko.observableArray(), display: ko.observableArray()};

            if(removeItemCallback) {
                listedItemFacet.removeItem = removeItemCallback;
            }

            listedItemFacet.selectedIds = listedItemFacet.computed(function () {
                return _.map(listedItemFacet.listedItems.values(), function(facetValue) {
                    return facetValue;
                });
            });

            var options = {ignoredIds: listedItemFacet.selectedIds};

            _.assign(options, listedItemFacet.customConstructorArgs);

            listedItemFacet.data = listedItemFacet.custom.selectorViewConstructor(listedItemFacet.facetObservable, options);

            listedItemFacet.facetObservable.subscribe(function (newValue) {
                if(newValue) {
                    //if the new value is from the combobox add it
                    if (!newValue.hasOwnProperty('listedItems') && newValue.hasOwnProperty('id')) {
                        var newValues = ko.toJS(newValue);
                        if(!_.includes(listedItemFacet.listedItems.values(), newValues.id)) {
                            listedItemFacet.listedItems.values.push(newValues.id);
                            listedItemFacet.listedItems.display.push(newValues.name);
                            listedItemFacet.addUpdateCallback(listedItemFacet);
                        }
                    } else if (newValue.hasOwnProperty('listedItems')){
                        //the new values are coming from a change in the listedItems
                        listedItemFacet.listedItems.values(newValue.listedItems.values());
                        listedItemFacet.listedItems.display(newValue.listedItems.display());
                        listedItemFacet.addUpdateCallback(listedItemFacet);

                    } else {
                        //new values are from saved filter
                        listedItemFacet.listedItems.values(newValue.values);
                        listedItemFacet.listedItems.display(newValue.display);
                    }

                    listedItemFacet.facetObservable(null);
                }
            });
            listedItemFacet.facetObservable(null);

            return listedItemFacet;

        };

        var PopoverFacet = function( facetObject, updateCallback ) {
            var lowInteger,
                highInteger,
                startDuration,
                endDuration,
                dateRange;
            var newValues = {values: []};

            var popoverFacet = new Facet ( facetObject, null, updateCallback );

            popoverFacet.popover = facetObject.popover;

            popoverFacet.popover.data.facet = facetObject;
            popoverFacet.popover.data.updateValues = function(valuesToSet) {
                switch(valuesToSet.facet.target) {
                    case self.SEARCH_FILTER_TYPE.DATERANGE:
                        var startDate, endDate, dates;
                        newValues = {values: []};

                        dateRange = valuesToSet.dateRangeObservable();
                        dates = valuesToSet.dateRangeObservable().split('/');

                        startDate = moment(dates[0]).format("L LT");
                        endDate = moment(dates[1]).format("L LT");

                        newValues.values.push(moment(dates[0]).toISOString() + "/" + moment(dates[1]).toISOString());
                        newValues.display = ko.i18n.renderString("dateRange.facet.display", {startDate: startDate, endDate: endDate});

                        break;

                    case self.SEARCH_FILTER_TYPE.DURATION:
                        startDuration = parseInt(valuesToSet.durationStart());
                        endDuration = parseInt(valuesToSet.durationEnd());

                        if(!_.isEmpty(newValues.values)){
                            newValues.values = [] ;
                        }

                        if (startDuration === 0 && endDuration > 0) {
                            newValues.values.push(startDuration + '/' + endDuration);
                            newValues.display= ko.i18n.renderString("durationFacet.duration.under", { duration: formattedDuration(endDuration) });

                        } else if (startDuration > 0 && endDuration === MAX_SUPPORTED_DURATION) {
                            newValues.values.push(startDuration + '/' + endDuration);
                            newValues.display = ko.i18n.renderString("durationFacet.duration.over", { duration: formattedDuration(startDuration) });

                        } else {
                            newValues.values.push(startDuration + '/' + endDuration);
                            newValues.display = ko.i18n.renderString("durationFacet.duration.between", { startDuration: formattedDuration(startDuration), endDuration: formattedDuration(endDuration) });
                        }

                        break;

                    case self.SEARCH_FILTER_TYPE.QUALITYEVALUATIONSCORE:
                        if(_.has(valuesToSet, 'values')){
                            var score = valuesToSet.values[0].split('/');
                            lowInteger = parseInt(score[0]);
                            highInteger = parseInt(score[1]);
                        } else {
                            lowInteger = parseInt(valuesToSet.lowInteger());
                            highInteger = parseInt(valuesToSet.highInteger());
                        }

                        if(!_.isEmpty(newValues.values)){
                            newValues.values = [] ;
                        }

                        if(lowInteger > 0 && highInteger === 100) {
                            newValues.values.push(lowInteger + '/' + highInteger);
                            newValues.display = ko.i18n.renderString("evaluationScoreFacet.scoreRange.over", {score: lowInteger});

                        } else if(lowInteger === 0 && highInteger > 0) {
                            newValues.values.push('0/'+highInteger);
                            newValues.display = ko.i18n.renderString("evaluationScoreFacet.scoreRange.under", {score: highInteger});

                        } else {
                            newValues.values.push(lowInteger + '/' + highInteger);
                            newValues.display = ko.i18n.renderString("evaluationScoreFacet.scoreRange.between", {lowScore: lowInteger, highScore: highInteger});
                        }
                        break;

                    case self.SEARCH_FILTER_TYPE.QUALITYEVALUATIONCRITICALSCORE:
                        if(_.has(valuesToSet, 'values')){
                            var score2 = valuesToSet.values[0].split('/');
                            lowInteger = parseInt(score2[0]);
                            highInteger = parseInt(score2[1]);
                        } else {
                            lowInteger = parseInt(valuesToSet.lowInteger());
                            highInteger = parseInt(valuesToSet.highInteger());
                        }

                        if(!_.isEmpty(newValues.values)){
                            newValues.values = [] ;
                        }

                        if(lowInteger > 0 && highInteger === 100) {
                            newValues.values.push(lowInteger+'/' + highInteger);
                            newValues.display = ko.i18n.renderString("evaluationCriticalScoreFacet.scoreRange.over", {score: lowInteger});

                        } else if(lowInteger === 0 && highInteger > 0) {
                            newValues.values.push('0/'+highInteger);
                            newValues.display = ko.i18n.renderString("evaluationCriticalScoreFacet.scoreRange.under", {score: highInteger});

                        } else {
                            newValues.values.push(lowInteger + '/' + highInteger);
                            newValues.display = ko.i18n.renderString("evaluationCriticalScoreFacet.scoreRange.between", {lowScore: lowInteger, highScore: highInteger});
                        }
                        break;
                } //END SWITCH

                popoverFacet.facetObservable(newValues);
                popoverFacet.addUpdateCallback(popoverFacet);
            };

            return popoverFacet;
        };

        self.createFacet = function (facetObject, removeItemCallback, updateCallback) {
            if(_.isUndefined(facetObject)) {
                throw new TypeError ("The facet is undefined, a facet must have the minimum of an ID");
            } else {
                switch(facetObject.id) {
                    case self.SEARCH_FILTER_TYPE.AGENT:
                    case self.SEARCH_FILTER_TYPE.DNIS:
                    case self.SEARCH_FILTER_TYPE.ANI:
                    case self.SEARCH_FILTER_TYPE.EVALUATION_FORM:
                    case self.SEARCH_FILTER_TYPE.EVALUATED_AGENT:
                    case self.SEARCH_FILTER_TYPE.EVALUATOR:
                    case self.SEARCH_FILTER_TYPE.QUEUES:
                    case self.SEARCH_FILTER_TYPE.WRAPUPCODE:
                        return new ListedItemFacet(facetObject, removeItemCallback, updateCallback);

                    case self.SEARCH_FILTER_TYPE.DATERANGE:
                    case self.SEARCH_FILTER_TYPE.DURATION:
                    case self.SEARCH_FILTER_TYPE.QUALITYEVALUATIONSCORE:
                    case self.SEARCH_FILTER_TYPE.QUALITYEVALUATIONCRITICALSCORE:
                        if(_.isUndefined(facetObject.popover)){
                            throw new ReferenceError("The popover property is not defined on the facetObject");
                        } else {
                            return new PopoverFacet(facetObject, updateCallback);
                        }
                        break;

                    default:
                        return new Facet(facetObject, null, updateCallback);
                }
            }
        };

    };
    return new SearchFacetFactory();
});

